let key = {};

key = {
    cryptoSecretKey: "1234567812345678",
    secretKey: "1A2B33dfescfuio"
}
export default {
    ...key
}

